<template>
  <div class="">
    <TitleWithBackButton
      title="Anagrafiche"
      back-route="Homepage"
      icon="mdi-account-cowboy-hat"
    ></TitleWithBackButton>

    <RegistriesHome
      :style="{
        'pointer-events': canManageRegistries ? 'all' : 'none',
        opacity: canManageRegistries ? '1' : '0.2',
      }"
    ></RegistriesHome>
    <ErrorDialogComponent
      v-if="showErrorDialog"
      :open-dialog="showErrorDialog"
      title="Utente non abilitato"
      :error-message="errorMessage"
      @close-error="goBack"
    >
    </ErrorDialogComponent>
  </div>
</template>

<script>
import RegistriesHome from "@/components/areas/registries/RegistriesHome.vue";
import TitleWithBackButton from "@/components/common/TitleWithBackButton.vue";
import ErrorDialogComponent from "@/components/common/errorComponent/ErrorDialogComponent.vue";

export default {
  components: {
    RegistriesHome,
    TitleWithBackButton,
    ErrorDialogComponent,
  },
  data: function () {
    return {
      showErrorDialog: false,
      errorMessage: "",
      registriesPermission: [],
    };
  },
  methods: {
    goBack() {
      this.$router.push({ name: "Homepage" });
    },
  },
  computed: {
    canManageRegistries() {
      if (
        this.registriesPermission.includes("view")
      )
        return true;
      else {
        this.showErrorDialog = true;
        this.errorMessage = "Accesso alle anagrafiche non autorizzato ";
        return false;
      }
    },
  },
  permissions: {
    Registries: {
      bind: "registriesPermission",
    },
  },
};
</script>

<style>
</style>